import { useAtomValue } from 'jotai';
import { unwrappedMarkersDescriptionsAtom } from '@/atoms/eventMarkers';
import { EventMapTooltip } from './EventMapTooltip';

export const EventLayerTooltip = ({
  eventId,
  obv,
  xg,
  gkSaveDifficultyXg,
}: {
  eventId: string;
  obv?: number | null;
  xg?: number | null;
  gkSaveDifficultyXg?: number | null;
}) => {
  const markersDescriptions = useAtomValue(unwrappedMarkersDescriptionsAtom);
  const description = markersDescriptions.find(({ eventId: id }) => id === eventId);
  if (!description) return null;
  return <EventMapTooltip markerDescription={description} obv={obv} xg={xg} gkSaveDifficultyXg={gkSaveDifficultyXg} />;
};
